import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';
import { type ResponsiveCardProps } from '@framework/ui/components/card/ResponsiveCard.tsx';
import styled from 'styled-components';
import { DossierResponsiveCard } from './cards/DossierResponsiveCard.tsx';
import { DossierCardCover } from './DossierCardCover.tsx';

const DOSSIER_PADDING = 4;

const StyledDossierCard = styled(DossierResponsiveCard)`
  &&& {
    border-radius: ${props => props.theme.borderRadius + DOSSIER_PADDING}px;
    > .ant-card-body {
      padding: ${DOSSIER_PADDING}px;
      border-radius: ${props => props.theme.borderRadius + DOSSIER_PADDING}px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    > .ant-card-cover {
      border-radius: ${props => props.theme.borderRadius + DOSSIER_PADDING}px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    /* > .ant-card-cover,
    > .ant-card-head,
    > .ant-card-body {
      background-color: #f1e46a;
    } */
  }
`;

export interface DossierCardProps extends ResponsiveCardProps {
  isDossierPage?: boolean;
  procedureDossier?: ProcedimentoConTask;
}

/**
 * ResponsiveCard personalizzata
 */
export function DossierCard(props: DossierCardProps) {
  const { children, isDossierPage, procedureDossier, ...cardProps } = props;

  return (
    <StyledDossierCard
      {...cardProps}
      cover={
        <DossierCardCover
          isDossierPage={isDossierPage}
          procedureDossier={procedureDossier}
        />
      }
    >
      {children}
    </StyledDossierCard>
  );
}
